import { useCallback, useEffect, useRef, useState } from "react";
import { Cpu, Search } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getApprovedUserData,
  processApproval,
  searchApprovals,
} from "../../api/finance/ApprovalProcessApi";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import {
  DateOnlyCellRenderer,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { approvalProcessValidation } from "../../components/validations/ApprovalProcessCreation";
import useUserCompany from "../../hooks/useUserCompany";
import { errorActions } from "../../store/error-slice";

const ApprovalProcess = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const userCompany = useUserCompany();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  //drawer
  const [tab, setTab] = useState(1);

  //flags
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  //errors
  const errorState = useSelector(
    (state) => state.error.deductApprovalHeaderErrors
  );
  const [currentErrors, setCurrentErrors] = useState({});

  // data
  const [approvalManagerData, setApprovalManagerData] = useState({
    apmNextApprove: "",
    apmStatus: "",
    apmReason: "",
    apmDescription: "",
  });
  const [isProcessing, setIsProcessing] = useState(false);

  //search ref
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  //search data
  const [approvalType, setApprovalType] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [item, setItem] = useState(null);
  const [status, setStatus] = useState(1);
  const [approvesStatus, setApprovesStatus] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [transporter, setTransporter] = useState(null);
  const [job, setJob] = useState(null);
  const [searchRes, setSearchRes] = useState([]);

  //dropdown
  const [approvalTypeOptions, setApprovalTypeOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [actionStatusOptions, setActionStatusOptions] = useState([]);
  const [approvesStatusOptions, setApprovesStatusOptions] = useState([]);
  const [reasonOptions, setReasonOptions] = useState([]);

  // popup
  const [showCloseButton, setShowCloseButton] = useState(false);
  const modalRef = useRef();
  const [tableData, setTableData] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);
  const gridRef = useRef();

  // grid check box
  const [availableUsers, setAvailableUsers] = useState({});

  useEffect(() => {
    (async () => {
      const itemType = await getDropdownData("item_type");
      const {
        status: statusData,
        approval_types: approvalType,
        approver_remark: reasonData,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "approval_types" },
        { key: "approver_remark" },
      ]);
      setStatusOptions(statusData);
      setReasonOptions(reasonData);
      setApprovalTypeOptions(approvalType);

      const filteredItemType = itemType.filter((item) => item.value !== 6);
      setItemTypeOptions(filteredItemType);

      const actionStatus = await getDropdownData("status");
      const filteredActionStatus = actionStatus.filter(
        (status) => status.text !== "Pending"
      );
      console.log("filteredActionStatus", filteredActionStatus);
      setActionStatusOptions(filteredActionStatus);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (approvalType === 4) {
        setItemType(6);
        setItem("");
      } else if (approvalType === 3) {
        setItemType("");
        setItem("");
        setVehicle("");
      }
      const approvesStatusData = await getOtherRefSearchDropdown({
        type: "approval_status",
        value: approvalType,
      });
      console.log("approvesStatusData", approvesStatusData);
      const updatedApproves = approvesStatusData.map((approvesStatusData) => {
        return {
          ...approvesStatusData,
          text: approvesStatusData.title,
        };
      });
      setApprovesStatusOptions(updatedApproves);
    })();
  }, [approvalType]);

  useEffect(() => {
    (async () => {
      try {
        console.log("itemType---", itemType);
        const item = await getOtherRefDetails({
          type: "item_type",
          value: itemType,
          searchText: "",
        });

        const updatedItems = item.map((item) => {
          return {
            ...item,
            text: item.title,
          };
        });

        setItemOptions(updatedItems);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    })();
  }, [itemType]);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (approvalType === null) {
      toast.error("Please select an approval type first", {
        autoClose: 5000,
        containerId: "Main",
      });
    } else {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
      const response = await searchApprovals({
        type: approvalType === 3 || approvalType === 4 ? 3 : null,
        approvesStatus: approvesStatus,
        status: status,
        active: null,
        user: user.username,
        from: fromDateRef.current.value,
        to: toDateRef.current.value,
        param1: approvalType === 3 ? itemType : approvalType === 4 ? 6 : null,
        param2: approvalType === 3 || approvalType === 4 ? item : null,
        param3: approvalType === 3 || approvalType === 4 ? vehicle : null,
        param4:
          approvalType === 3 ? transporter : approvalType === 4 ? job : null,
        param5: approvalType === 3 ? null : null,
        company: company,
      });
      console.log("search response ", response);
      setSearchRes(response);
      setSearchSubmitLoading(false);
    }
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    setApprovesStatus(null);
    setItemType(null);
    setItem(null);
    setStatus(null);
    setVehicle(null);
    setTransporter(null);
    setJob(null);
    setSearchFieldReset(true);
    fromDateRef.current.reset();
    toDateRef.current.reset();
  };

  const viewApprovalList = (dedId, detCode) => {
    const handleViewClick = (e) => {
      e.stopPropagation(); // Prevent event propagation
      // Handle opening GalleryComp here
      handlePopUpChange(dedId, detCode);
    };
    const handlePopUpChange = async (dedId, detCode) => {
      setShowCloseButton(true);
      const code = detCode.replace(/\D/g, "");
      const detId = parseInt(code, 10);

      const response = await getApprovedUserData(dedId, detId);
      console.log("getApprovedUserData", response);
      setTableData(response);
      modalRef.current.showModal();
    };

    return (
      <Button
        className="ui primary button"
        style={{ display: "flex", alignItems: "center" }}
        onClick={handleViewClick}
        label="View Approved List"
      />
    );
  };

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  const requestProcess = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    setSearchSubmitLoading(true);
    setIsProcessing(true);
    const approvalErrors = approvalProcessValidation(approvalManagerData);
    if (Object.keys(approvalErrors).length > 0) {
      dispatch(
        errorActions.validateApprovalProcessCreation({
          approvalProcessData: approvalManagerData,
        })
      );
      setIsSubmitLoading(false);
      setSearchSubmitLoading(false);
      toast.error("There was an error Update Approval Process", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      const selectedRequestIds = selectedRows?.map((item) => item.appId);
      console.log("selectedRequestIds", selectedRequestIds);
      if (selectedRequestIds.length === 0) {
        setIsSubmitLoading(false);
        setSearchSubmitLoading(false);
        toast.error("Please select an Approval to process!", {
          autoClose: 5000,
          containerId: "Main",
        });
        setIsProcessing(false);
        return;
      } else {
        const response = await processApproval({
          apmIdList: selectedRequestIds,
          approvesManagerRequest: approvalManagerData,
          approvalType: approvalType,
          author: user.username,
        });
        if (response === "approve") {
          toast.success("Deduction approved!", {
            autoClose: 5000,
            containerId: "Main",
          });
        } else if (response === "reject") {
          toast.warning("Deduction rejected!", {
            autoClose: 5000,
            containerId: "Main",
          });
        }
        await handleSearchSubmit(e);
        setSelectedRows([]);
        setIsSubmitLoading(false);
        setSearchSubmitLoading(false);
      }
    }
  };

  return (
    <>
      <Modal ref={modalRef} closeButton={showCloseButton}>
        <>
          <Grid
            heading="Approval List"
            config={[
              {
                headerName: "Id",
                field: "apdId",
                sort: "asc",
                hide: true,
              },
              {
                headerName: "Approval Name",
                field: "approvalName",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Approver Name",
                field: "approvedBy",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Current Status",
                field: "approvedStatus",
                cellRenderer: StatusCellStyle,
              },
            ]}
            content={tableData}
          />
        </>
      </Modal>

      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Search size={15} style={{ marginRight: "5px" }} />
            </span>
            Search
          </div>
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Click here to expand search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>
                <div className="two fields">
                  <Dropdown
                    label="Approval Type"
                    placeholder="Approval Type"
                    options={approvalTypeOptions}
                    value={approvalType}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setApprovalType(data.value);
                    }}
                    required={true}
                  />
                </div>
                <h4 className="ui dividing header"></h4>

                {approvalType === 3 ? (
                  <div className="four fields">
                    <Dropdown
                      label="Item Type"
                      placeholder="Item Type"
                      options={itemTypeOptions}
                      value={itemType}
                      style={{ height: "5px" }}
                      onChange={(e, data) => {
                        setItemType(data.value);
                      }}
                    />

                    <Dropdown
                      label="Item"
                      placeholder="Item"
                      options={itemOptions}
                      value={item}
                      style={{ height: "5px" }}
                      onChange={(e, data) => {
                        setItem(data.value);
                      }}
                    />

                    <SearchDropdown
                      key={1}
                      editMode={false}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      onResultSelect={(data) => setVehicle(data)}
                      clearable={true}
                      onClear={() => {
                        setVehicle(null);
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "vehicle",
                      }}
                      label="Vehicle"
                    />

                    <SearchDropdown
                      key={1}
                      editMode={false}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      onResultSelect={(data) => setTransporter(data)}
                      clearable={true}
                      onClear={() => {
                        setTransporter(null);
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "stakeholder_type",
                        value: "Transporter",
                      }}
                      label="Transporter"
                    />
                  </div>
                ) : null}
                {approvalType === 4 ? (
                  <div className="four fields">
                    <Dropdown
                      label="Item"
                      placeholder="Item"
                      options={itemOptions}
                      value={item}
                      style={{ height: "5px" }}
                      onChange={(e, data) => {
                        setItem(data.value);
                      }}
                    />

                    <SearchDropdown
                      key={1}
                      editMode={false}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      onResultSelect={(data) => setVehicle(data)}
                      clearable={true}
                      onClear={() => {
                        setVehicle(null);
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "vehicle",
                      }}
                      label="Vehicle"
                    />
                    {/*<SearchDropdown*/}
                    {/*    key={1}*/}
                    {/*    editMode={false}*/}
                    {/*    reset={searchFieldReset}*/}
                    {/*    setReset={setSearchFieldReset}*/}
                    {/*    onResultSelect={(data) =>*/}
                    {/*        setTransporter(data)*/}
                    {/*    }*/}
                    {/*    api={getOtherRefSearchDropdown}*/}
                    {/*    apiDependency={{*/}
                    {/*        type: "stakeholder_type",*/}
                    {/*        value: "Transporter",*/}
                    {/*    }}*/}
                    {/*    label="Transporter"*/}
                    {/*    disabled={!vehicle}*/}
                    {/*/>*/}
                    <SearchDropdown
                      key={1}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      onResultSelect={(data) => setJob(data)}
                      clearable={true}
                      onClear={() => {
                        setJob(null);
                      }}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "JOB",
                        param1: vehicle ? vehicle : "",
                      }}
                      label="Job"
                      disabled={!vehicle}
                    />
                  </div>
                ) : null}
                {approvalType ? (
                  <div className="four fields">
                    {/*<Dropdown*/}
                    {/*    label="Approves Status"*/}
                    {/*    placeholder="Approves Status"*/}
                    {/*    options={approvesStatusOptions}*/}
                    {/*    value={approvesStatus}*/}
                    {/*    style={{height: "5px"}}*/}
                    {/*    onChange={(e, data) => {*/}
                    {/*        setApprovesStatus(data.value);*/}
                    {/*    }}*/}
                    {/*/>*/}

                    {/*<Dropdown*/}
                    {/*    */}
                    {/*    label="Main Status"*/}
                    {/*    placeholder="Status"*/}
                    {/*    options={statusOptions}*/}
                    {/*    value={status}*/}
                    {/*    style={{height: "5px"}}*/}
                    {/*    onChange={(e, data) => {*/}
                    {/*        setStatus(data.value);*/}
                    {/*    }}*/}
                    {/*/>*/}

                    <Input
                      label="From Date"
                      type="date"
                      name="from_date"
                      placeholder="From Date"
                      ref={fromDateRef}
                    />
                    <Input
                      label="To Date"
                      type="date"
                      name="to_date"
                      placeholder="To Date"
                      ref={toDateRef}
                    />
                  </div>
                ) : null}
                {approvalType !== "" ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="field" style={{ width: "100%" }}>
                      <Button
                        template="search"
                        onClick={(e) => {
                          handleSearchSubmit(e);
                        }}
                      />
                      <Button
                        template="searchReset"
                        onClick={(e) => {
                          handleSearchReset(e);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Grid
                  ref={gridRef}
                  onSelectionChanged={handleSelectionChanged}
                  isLoading={searchFetchLoading}
                  multiRowSelection={true}
                  showDownloadButton={selectedRows && selectedRows?.length > 0}
                  downloadParam={JSON.stringify(selectedRows)}
                  downloadAction="Deduction Approval Excel Download"
                  reportName={"Deduction Approval Records.csv"}
                  autoHeight={false}
                  rowHeight={60}
                  // stopEditingWhenCellsLoseFocus={true}
                  content={searchRes}
                  config={[
                    {
                      headerName: "Id",
                      field: "appRowId",
                      sort: "desc",
                      hide: true,
                    },
                    {
                      headerName: "Transactional Code",
                      field: "detCode",
                      cellRenderer: ResizableScrollingTextRenderer,
                      headerCheckboxSelection: true,
                      checkboxSelection: (params) => {
                        // return checkUserAvailable(params.data.appId);
                        return params.data.user_status || false;
                      },
                    },
                    {
                      headerName: "Main Deduction Code",
                      field: "appCode",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Transporter",
                      field: "appTransporter",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Item Type ",
                      field: "appItemType",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Item Name ",
                      field: "appItemName",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Vehicle",
                      field: "appVehicle",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Ref No.",
                      field: "appRefNo",
                    },
                    {
                      headerName: "Terminal Id",
                      field: "appTerminalId",
                    },
                    {
                      headerName: "Installment Amount",
                      field: "appAmount",
                    },
                    {
                      headerName: "Charge Name",
                      field: "appChargeName",
                    },
                    {
                      headerName: "Current Earning",
                      field: "appCurrentEarning",
                    },
                    {
                      headerName: "Start",
                      field: "appStart",
                      cellRenderer: DateOnlyCellRenderer,
                    },
                    {
                      headerName: "End",
                      field: "appEnd",
                      cellRenderer: DateOnlyCellRenderer,
                    },
                    // {
                    //     headerName: "Last Approved By",
                    //     field: "appApprovedBy",
                    //     cellRenderer: ResizableScrollingTextRenderer,
                    // },
                    {
                      headerName: "Approved List",
                      field: "appApprovedBy",
                      cellRenderer: (params) => {
                        return viewApprovalList(
                          params.data.appTypeId,
                          params.data.detCode
                        );
                      },
                      minWidth: 250,
                    },
                    {
                      headerName: "Conformation Date",
                      field: "appConfirmationDate",
                    },
                    {
                      headerName: "Approval Level Name",
                      field: "approvalName",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Approval Level Status",
                      field: "approvedStatus",
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Remarks",
                      field: "appRemarks",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Status",
                      field: "appConfirmation",
                      cellRenderer: StatusCellStyle,
                    },
                  ]}
                  onCellDoubleClicked={async (props) => {
                    setSearchFetchLoading(true);
                    // const response = await deductionApprovalById(props.data.appId);
                    // console.log("-------");
                    // console.log(response);
                    // setEditApproval(response);
                    setEditMode(true);
                    setIsDrawerOpen(true);
                    setSearchFetchLoading(false);
                  }}
                />
                {selectedRows.length > 0 && (
                  <form className="ui form segment">
                    <h4 className="ui dividing header">Action</h4>
                    <div className="four fields ">
                      <Dropdown
                        required={true}
                        label="Action"
                        error={currentErrors.apmStatus}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { apmStatus: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        placeholder="Action"
                        options={actionStatusOptions}
                        value={approvalManagerData.apmStatus}
                        style={{ height: "5px" }}
                        onChange={(e, data) => {
                          setApprovalManagerData((prevState) => ({
                            ...prevState,
                            apmStatus: data.value,
                          }));
                        }}
                        clearable={false}
                      />
                      <Dropdown
                        disabled={approvalManagerData.apmStatus === 2}
                        label="Reason"
                        error={currentErrors.apmReason}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { apmReason: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        placeholder="Reason"
                        options={reasonOptions}
                        value={approvalManagerData.apmReason}
                        style={{ height: "5px" }}
                        onChange={(e, data) => {
                          setApprovalManagerData((prevState) => ({
                            ...prevState,
                            apmReason: data.value,
                          }));
                        }}
                        clearable={false}
                      />
                    </div>
                    <div className="two fields ">
                      <Input
                        label="Remarks"
                        placeholder="Remarks"
                        error={currentErrors.apmDescription}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { apmDescription: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        name="remarks"
                        value={approvalManagerData.apmDescription}
                        onChange={(e) => {
                          setApprovalManagerData((prevState) => ({
                            ...prevState,
                            apmDescription: e.target.value,
                          }));
                        }}
                      />
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div className="field">
                          <Button
                            className="ui primary right floated button"
                            isLoading={isSubmitLoading}
                            onClick={(e) => {
                              requestProcess(e);
                            }}
                            label="Process"
                            Icon={Cpu}
                          />
                          <Button
                            template="reset"
                            onClick={(e) => {
                              // resetActionForm(e);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default ApprovalProcess;
